import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { useAuth } from '../../hooks/useAuth';
import { authDebug } from '../../lib/auth-debug';

export default function CondominiumAdminRoute({ children }: { children: ReactNode }) {
  const { userDoc, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!userDoc) {
    return <Navigate to="/login" replace />;
  }

  const canAccess = !!userDoc.isGlobalAdmin || !!userDoc.isCondominiumManager;
  if (!canAccess) {
    authDebug('CondominiumAdminRoute bloqueou acesso', {
      email: userDoc.email,
      uid: userDoc.uid,
      isGlobalAdmin: userDoc.isGlobalAdmin,
      isCondominiumManager: userDoc.isCondominiumManager,
      path: window.location.pathname,
    });
    return <Navigate to="/404" replace />;
  }

  return <>{children}</>;
}
